import { MouseEventHandler } from 'react';

import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import useWorkingProjectColorsByV2Names from '@/utils/use-working-project-colors-by-v2-names';
import Text from '@ui/text/text/text';

import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type AddNewSessionCardProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const AddNewSessionCard = ({ onClick }: AddNewSessionCardProps) => {
  const { primary: _primaryColor } = useWorkingProjectColorsByV2Names();
  const primaryColor = _primaryColor && _primaryColor[0];

  return (
    <Button className="clear-button" height="180px" width="320px" onClick={onClick} hoverOpacity={0.8}>
      <Container
        width="100%"
        height="100%"
        borderRadius="16px"
        className="position-relative overflow-hidden flex fd-row jc-center ai-center"
        border={`1px dashed ${primaryColor}`}
      >
        <div className="margin-r-8">
          <Icon name={ICONS.ADD} size={12} color={primaryColor} />
        </div>
        <div>
          <Text color={primaryColor} className="L2">
            Add session
          </Text>
        </div>
      </Container>
    </Button>
  );
};

export default AddNewSessionCard;
